import { Component } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import IcCompose from 'components/icons/Compose';
import { MdSearch } from 'react-icons/md';
import { MdClose } from 'react-icons/md';
import Search from 'components/Search';
import { size, spacing, ButtonNew, ButtonReset } from 'ui';
import { withTranslation } from 'react-i18next';
// import { Spring } from 'react-spring';

const Header = styled.div`
  background-color: #fff;
  position: absolute;
  height: 58px;
  top: 0;
  right: 0;
  left: 0;
  box-shadow: 0 1px 0 #e0e4e8;
  padding: ${spacing(0.5)} ${spacing()};
  line-height: 26px;
  font-weight: 500;
  z-index: 1;
`;

const WrapperIcon = styled(ButtonReset)`
  font-size: ${size(2.5)};
  color: ${({ theme }) => theme.textLighter};
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
`;

const WrapperSearch = styled.div`
  position: absolute;
  z-index: 1;
  top: ${spacing(0.625)};
  bottom: ${spacing(0.625)};
  left: ${spacing()};
  right: ${spacing()};
`;

class SidebarConversationsHeader extends Component {
  state = {
    showInputSearch: false,
  };

  componentDidUpdate(prevProps, prevState) {
    const { showInputSearch } = this.state;
    if (showInputSearch && !prevState.showInputSearch) {
      this.search.input.focus();
    }
  }

  render() {
    const { search, onUpdateSearch, onClearSearch, t } = this.props;
    const { showInputSearch } = this.state;

    return (
      <Header>
        {/* <Spring
          from={{ opacity: 0, translateX: 100, display: 'none' }}
          to={{
            opacity: showInputSearch ? 1 : 0,
            translateX: showInputSearch ? 0 : 100,
            display: showInputSearch ? 'block' : 'none',
          }}
        >
          {({ opacity, translateX, display }) => ( */}
        {showInputSearch && (
          <WrapperSearch
          // style={{
          //   opacity,
          //   display,
          //   transform: `translateX(${translateX}%)`,
          // }}
          >
            <Wrapper>
              <Search
                secondary
                value={search}
                onChange={onUpdateSearch}
                onClear={onClearSearch}
                ref={c => (this.search = c)}
              />
              <WrapperIcon
                onClick={() => this.setState({ showInputSearch: false })}
              >
                <MdClose />
              </WrapperIcon>
            </Wrapper>
          </WrapperSearch>
        )}
        {/* )}
        </Spring>
        <Spring
          from={{ opacity: 1, display: 'block' }}
          to={{
            opacity: showInputSearch ? 0 : 1,
            display: showInputSearch ? 'none' : 'block',
          }}
        >
          {({ opacity, display }) => ( */}
        {!showInputSearch && (
          <Wrapper /*style={{ opacity, display }}*/>
            <ButtonNew
              isPrimary
              as={Link}
              to="/mes-echanges/mes-messages/nouveau"
            >
              <IcCompose />
              {t('newMessage')}
            </ButtonNew>
            <WrapperIcon
              onClick={() => this.setState({ showInputSearch: true })}
            >
              <MdSearch />
            </WrapperIcon>
          </Wrapper>
        )}
        {/* )}
        </Spring> */}
      </Header>
    );
  }
}

export default withTranslation('communications')(SidebarConversationsHeader);
